/* Native controls keep playback available without JavaScript. No autoplay. */
(() => {
  if (window.ilifeFilmListenerInstalled) return;
  window.ilifeFilmListenerInstalled = true;
  document.addEventListener('play', event => {
    const current = event.target;
    if (!(current instanceof HTMLVideoElement) || !current.closest('[data-ilife-film]')) return;
    document.querySelectorAll('[data-ilife-film] video').forEach(video => {
      if (video !== current) video.pause();
    });
  }, true);
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) document.querySelectorAll('[data-ilife-film] video').forEach(video => video.pause());
  });
})();
